import { InviteLink } from '@weblite/ts-action/hall'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { PopupMenuItem, PopupMenuList } from '$common/popup-menu'
import { RemoveIcon } from '$common/icons/remove'
import { EditOutlinedIcon } from '$common/icons'
// Logic
import { revokeInviteLink } from '$logic/hall'
import { t } from '$i18n'
import { openEditInviteLink } from '$logic/router'

interface Props {
  link: InviteLink
  isOpen: boolean
}

export function ActiveLinkMenu({ link, isOpen }: Props) {
  return (
    <PopupMenuList open={isOpen}>
      <PopupMenuItem
        text={t('menu.inviteLink.edit')}
        onClick={async () => {
          await closeCurrentModal()
          openEditInviteLink(link.roomId, link)
        }}
      >
        <EditOutlinedIcon sx={{ color: 'secondary.main' }} />
      </PopupMenuItem>

      <PopupMenuItem
        text={t('menu.inviteLink.revoke')}
        onClick={async () => {
          await revokeInviteLink(link.roomId, link.link)
          await closeCurrentModal()
        }}
        error
      >
        <RemoveIcon sx={{ color: 'error.main' }} />
      </PopupMenuItem>
    </PopupMenuList>
  )
}
